/**
 * Édition inline d'une chanson dans le cart drawer — pills compactes éditables.
 *
 * Chaque attribut est une pill (snippets/lcu-cart-song-attrs.liquid). Les pills
 * éditables portent un crayon ; un clic ouvre l'éditeur du champ, rendu en pleine
 * largeur juste sous la pill. Enregistrer met à jour la ligne via /cart/change.js
 * SANS toucher aux autres lignes → les upsells sont préservés.
 *
 * Champs à choix (Occasion / Style / Ambiance) : <select> peuplé depuis
 * localStorage.lcu_song_options (écrit par le configurateur). Si absent → bascule
 * en saisie libre pré-remplie (aucun cul-de-sac).
 *
 * Sécurité conversion : aucune interception du form checkout ni du bouton
 * name="checkout". Les champs n'ont pas d'attribut name → rien ne part au checkout.
 * Entrée dans un champ = enregistrer (jamais de submit implicite du form panier).
 */
(function () {
  'use strict';

  var OPTIONS_KEY = 'lcu_song_options';
  var editInFlight = false;

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getSectionsParam() {
    var drawer = getCartDrawer();
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return '';
    return drawer
      .getSectionsToRender()
      .map(function (s) { return s.id; })
      .join(',');
  }

  function getOptions() {
    try {
      var raw = localStorage.getItem(OPTIONS_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function getInput(panel) {
    return panel.querySelector('[data-attr-input]');
  }

  function getPillFor(panel) {
    var prev = panel.previousElementSibling;
    return prev && prev.hasAttribute('data-attr-edit') ? prev : null;
  }

  // ── Peuplement d'un champ à choix ──────────────────────────────────────
  function populateChoice(panel) {
    var choiceName = panel.getAttribute('data-attr');
    var current = panel.getAttribute('data-current') || '';
    var control = getInput(panel);
    if (!control) return;

    var options = getOptions();
    var list = options && options[choiceName];

    // Fallback saisie libre si les options ne sont pas disponibles.
    if (!list || !list.length) {
      if (control.tagName === 'SELECT') {
        var input = document.createElement('input');
        input.type = 'text';
        input.className = 'lcu-attr-editor__control';
        input.setAttribute('data-attr-input', '');
        input.setAttribute('value', current);
        input.value = current;
        input.autocomplete = 'off';
        control.parentNode.replaceChild(input, control);
        var other = panel.querySelector('[data-attr-other]');
        if (other) other.hidden = true;
      }
      return;
    }

    if (control.tagName !== 'SELECT') return;

    control.innerHTML = '';
    var matched = false;
    list.forEach(function (opt) {
      var o = document.createElement('option');
      o.value = opt.label;
      o.textContent = (opt.emoji ? opt.emoji + ' ' : '') + opt.label;
      if (opt.has_other) o.setAttribute('data-has-other', '1');
      if (opt.label === current) { o.selected = true; matched = true; }
      control.appendChild(o);
    });
    if (!matched && current) {
      var extra = document.createElement('option');
      extra.value = current;
      extra.textContent = current;
      extra.selected = true;
      control.appendChild(extra);
    }
    syncOther(panel);
  }

  function syncOther(panel) {
    var other = panel.querySelector('[data-attr-other]');
    if (!other) return;
    var control = getInput(panel);
    if (!control || control.tagName !== 'SELECT') { other.hidden = true; return; }
    var selected = control.options[control.selectedIndex];
    var isOther = selected && selected.getAttribute('data-has-other') === '1';
    other.hidden = !isOther;
  }

  // ── Ouverture / fermeture d'un éditeur ─────────────────────────────────
  function openPanel(panel) {
    var open = document.querySelectorAll('.lcu-attr-editor:not([hidden])');
    Array.prototype.forEach.call(open, function (el) {
      if (el !== panel) closePanel(el);
    });

    if (panel.getAttribute('data-attr-type') === 'choice') populateChoice(panel);

    panel.hidden = false;
    var pill = getPillFor(panel);
    if (pill) pill.classList.add('is-editing');

    var control = getInput(panel);
    if (control) {
      try { control.focus({ preventScroll: true }); } catch (e) { control.focus(); }
    }
    panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function closePanel(panel) {
    var pill = getPillFor(panel);
    if (pill) pill.classList.remove('is-editing');

    var control = getInput(panel);
    if (control) {
      if (control.tagName === 'SELECT') populateChoice(panel);
      else control.value = control.defaultValue;
    }
    var other = panel.querySelector('[data-attr-other]');
    if (other) { other.value = other.defaultValue; other.hidden = true; }

    var err = panel.querySelector('.lcu-attr-editor__error');
    if (err) { err.hidden = true; err.textContent = ''; }

    panel.hidden = true;
  }

  function showError(panel) {
    var err = panel.querySelector('.lcu-attr-editor__error');
    if (err) {
      err.textContent = 'Impossible d’enregistrer, veuillez réessayer.';
      err.hidden = false;
    }
  }

  // ── Enregistrement d'un champ ──────────────────────────────────────────
  function savePanel(panel) {
    if (editInFlight) return;
    var wrapper = panel.closest('[data-song-attrs]');
    var lineKey = wrapper && wrapper.getAttribute('data-line-key');
    var attrName = panel.getAttribute('data-attr');
    if (!lineKey || !attrName) return;

    var control = getInput(panel);
    if (!control) return;
    var value = (control.value || '').trim();
    var otherKey = panel.getAttribute('data-other-key');
    var otherInput = panel.querySelector('[data-attr-other]');
    var isSelect = control.tagName === 'SELECT';

    var saveBtn = panel.querySelector('.lcu-attr-editor__save');
    var err = panel.querySelector('.lcu-attr-editor__error');
    if (err) err.hidden = true;

    // Qualité commande : un champ éditable ne doit pas être vidé (ex. l'histoire).
    if (!value) {
      if (err) { err.textContent = 'Ce champ ne peut pas être vide.'; err.hidden = false; }
      if (control.focus) control.focus();
      return;
    }

    editInFlight = true;
    if (saveBtn) saveBtn.disabled = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === lineKey) { item = cart.items[i]; break; }
        }
        if (!item) throw new Error('Line item introuvable');

        var props = {};
        var base = item.properties || {};
        Object.keys(base).forEach(function (k) { props[k] = base[k]; });

        props[attrName] = value;

        if (otherKey) {
          if (isSelect && otherInput && !otherInput.hidden) {
            var otherVal = (otherInput.value || '').trim();
            if (otherVal) props[otherKey] = otherVal;
            else delete props[otherKey];
          } else {
            delete props[otherKey];
          }
        }

        var body = { id: lineKey, quantity: item.quantity, properties: props };
        var sections = getSectionsParam();
        if (sections) {
          body.sections = sections;
          body.sections_url = window.location.pathname;
        }

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (res) {
          if (!res.ok) throw new Error('cart/change.js ' + res.status);
          return res.json();
        });
      })
      .then(function (response) {
        editInFlight = false;
        var drawer = getCartDrawer();
        if (drawer && response && response.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(response);
        } else {
          window.location.reload();
        }
      })
      .catch(function (e) {
        console.error('[LCU] Song attr edit failed:', e);
        editInFlight = false;
        if (saveBtn) saveBtn.disabled = false;
        showError(panel);
      });
  }

  function panelFromEditControl(el) {
    return el.closest('[data-attr-panel]');
  }

  // ── Délégation (survit aux renderContents) ─────────────────────────────
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-attr-edit]');
    if (pill) {
      e.preventDefault();
      var panel = pill.nextElementSibling;
      if (panel && panel.hasAttribute('data-attr-panel')) {
        if (panel.hidden) openPanel(panel);
        else closePanel(panel);
      }
      return;
    }
    var cancelBtn = e.target.closest('[data-attr-cancel]');
    if (cancelBtn) {
      e.preventDefault();
      var pc = panelFromEditControl(cancelBtn);
      if (pc) closePanel(pc);
      return;
    }
    var saveBtn = e.target.closest('[data-attr-save]');
    if (saveBtn) {
      e.preventDefault();
      var ps = panelFromEditControl(saveBtn);
      if (ps) savePanel(ps);
      return;
    }
  });

  // <cart-drawer-items> (Dawn) écoute `change` en délégation et interprète TOUT
  // change comme un changement de quantité (→ bulle native « incréments de… » +
  // erreur resetQuantityInput). On stoppe la propagation des change de NOS champs
  // en phase capture (avant que Dawn ne les voie). Ne touche pas au champ quantité
  // réel (on ne cible que nos data-attr-input / data-attr-other).
  document.addEventListener(
    'change',
    function (e) {
      var field = e.target.closest && e.target.closest('[data-attr-input], [data-attr-other]');
      if (!field || !field.closest('[data-song-attrs]')) return;
      e.stopPropagation();
      var sel = e.target.closest('select[data-attr-input]');
      if (sel) {
        var panel = panelFromEditControl(sel);
        if (panel) syncOther(panel);
      }
    },
    true
  );

  // Garde-fou conversion : champs dans le form panier → Entrée déclencherait le
  // submit implicite (checkout prématuré). On l'intercepte : Entrée = enregistrer.
  // Exception : la zone de texte (Souvenirs), où Entrée reste un saut de ligne.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var el = e.target.closest('[data-attr-input], [data-attr-other]');
    if (!el || el.tagName === 'TEXTAREA') return;
    e.preventDefault();
    var panel = panelFromEditControl(el);
    if (panel) savePanel(panel);
  });
})();
